import React from 'react';

import Form from 'react-bootstrap/Form';

import Loading from './Loading';
import Error from './Error';
import {apiBaseUrl} from './Config';

class CategoryFilter extends React.Component {
    constructor(props) {
	super(props);
	this.state = {
	    error: null,
	    isLoaded: false,
	    categories: []
	};

	this.resource = apiBaseUrl + "companyCategories";
    }

    componentDidMount() {
	fetch(this.resource, {
	    headers: {
		"Authorization": "Bearer " + this.props.token,
		"Accept": "application/json"
	    }
	})
	    .then(response => {
		if (response.status === 401) {
		    this.props.onAuthError();
		}
		
		return response.json()
	    })
	    .then((result) => {
		this.setState({
		    isLoaded: true,
		    categories: result
		});
	    })
	    .catch((error) => {
		this.setState({
		    isLoaded: true,
		    error
		});
	    })
    }

    render() {
	const { error, isLoaded, categories } = this.state;
	
	if (error) {
	    return (
		<Error error={error} />
	    );
	} else if (!isLoaded) {
	    return (
		<Loading />
	    );
	} else {
	    return (
		<Form>
		    <Form.Group>
			<Form.Select value={this.props.filterCategory} onChange={this.props.onHandleFilterCategoryChange}>
			    <option></option>
			    {categories.map(category => (
				<option value={category.name} key={category.id}>{category.name}</option>
			    ))}
			</Form.Select>
		    </Form.Group>
		</Form>
	    );
	}
    }
}

export default CategoryFilter;
